import { useState } from 'react'

import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import { generateBodemDeadline } from '../../util/subproces-bodem-util'

interface Props {
  subproces: Subproces
  onClose: () => void
}

const options = [
  { label: 'Aanvraag samenstellen', value: 'samenstellen_aanvraag' },
  { label: 'Bodemadvies opstellen', value: 'review' },
  {
    label: 'Aanvullend bodemonderzoek nodig',
    value: 'aanvullend_onderzoek_nodig',
  },
] as const satisfies readonly { label: string; value: Subproces['status'] }[]
export const ResumeBodem = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()

  const [reden, setReden] = useState<(typeof options)[number] | null>(null)

  const [dueDate, setDueDate] = useState<Date | null>(null)

  const onSubmitClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      // @ts-expect-error button is disabled when reden is null
      status: reden.value,
      // @ts-expect-error button is disabled when reden is null
      dueDate: dueDate.toISOString(),
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  const onChangeReden = (_, reden: (typeof options)[number] | null) => {
    setReden(reden)

    if (reden) {
      setDueDate(generateBodemDeadline(reden.value))
    } else {
      setDueDate(null)
    }
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Typography variant="body1" gutterBottom>
          Wat is de nieuwe status van het subproces? De opleverdatum wordt
          automatisch aangepast.
        </Typography>
        <Autocomplete
          value={reden}
          fullWidth
          options={options}
          onChange={onChangeReden}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => {
            return (
              <TextField variant="standard" {...params} label="Nieuwe status" />
            )
          }}
        />
        <DatePicker
          label="Opleverdatum"
          value={dueDate}
          disabled={true}
          slotProps={{
            field: { clearable: true },
            textField: {
              variant: 'standard',
              sx: { pr: 1, mt: 1 },
              fullWidth: true,
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'} disabled={!reden}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
